/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Stage_Route_SynthesisInputs */

const bn_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রুট সংশ্লেষণ`)
};

const de_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routensynthese`)
};

const el_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σύνθεση διαδρομής`)
};

const en_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Route synthesis`)
};

const es_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Síntesis de ruta`)
};

const fr_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synthèse d’itinéraire`)
};

const hi_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्ग संश्लेषण`)
};

const hu_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Útvonal szintézis`)
};

const id_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sintesis rute`)
};

const it_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sintesi del percorso`)
};

const ja_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ルート合成`)
};

const ko_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경로 합성`)
};

const nl_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routesynthese`)
};

const pl_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synteza tras`)
};

const pt_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Síntese de rota`)
};

const ru_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синтез маршрутов`)
};

const sv_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vägsyntes`)
};

const tr_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rota sentezi`)
};

const uk_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синтез маршруту`)
};

const vi_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng hợp lộ trình`)
};

const zh_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`路线综合`)
};

const zh_hant_cipher_stage_route_synthesis = /** @type {(inputs: Cipher_Stage_Route_SynthesisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`路線綜合`)
};

/**
* | output |
* | --- |
* | "Route synthesis" |
*
* @param {Cipher_Stage_Route_SynthesisInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_stage_route_synthesis = /** @type {((inputs?: Cipher_Stage_Route_SynthesisInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Stage_Route_SynthesisInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_stage_route_synthesis(inputs)
	if (locale === "de") return de_cipher_stage_route_synthesis(inputs)
	if (locale === "el") return el_cipher_stage_route_synthesis(inputs)
	if (locale === "en") return en_cipher_stage_route_synthesis(inputs)
	if (locale === "es") return es_cipher_stage_route_synthesis(inputs)
	if (locale === "fr") return fr_cipher_stage_route_synthesis(inputs)
	if (locale === "hi") return hi_cipher_stage_route_synthesis(inputs)
	if (locale === "hu") return hu_cipher_stage_route_synthesis(inputs)
	if (locale === "id") return id_cipher_stage_route_synthesis(inputs)
	if (locale === "it") return it_cipher_stage_route_synthesis(inputs)
	if (locale === "ja") return ja_cipher_stage_route_synthesis(inputs)
	if (locale === "ko") return ko_cipher_stage_route_synthesis(inputs)
	if (locale === "nl") return nl_cipher_stage_route_synthesis(inputs)
	if (locale === "pl") return pl_cipher_stage_route_synthesis(inputs)
	if (locale === "pt") return pt_cipher_stage_route_synthesis(inputs)
	if (locale === "ru") return ru_cipher_stage_route_synthesis(inputs)
	if (locale === "sv") return sv_cipher_stage_route_synthesis(inputs)
	if (locale === "tr") return tr_cipher_stage_route_synthesis(inputs)
	if (locale === "uk") return uk_cipher_stage_route_synthesis(inputs)
	if (locale === "vi") return vi_cipher_stage_route_synthesis(inputs)
	if (locale === "zh") return zh_cipher_stage_route_synthesis(inputs)
	return zh_hant_cipher_stage_route_synthesis(inputs)
});